var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContract = function SvgContract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.142,
    height: 21.909,
    viewBox: "0 0 18.142 21.909",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", {
    id: "Group_9933",
    "data-name": "Group 9933",
    transform: "translate(0 0)"
  }, React.createElement("g", {
    id: "Group_9932",
    "data-name": "Group 9932",
    transform: "translate(0 0)"
  }, React.createElement("path", {
    id: "Path_7065_-_Outline",
    "data-name": "Path 7065 - Outline",
    d: "M-18979.8,9221.274l2.842,2.714-2.088.645h-1.391l-.021-.479.021-2.131h.488c.166-.028-.8-.539-.111-.691Zm2.145,3.358a21.646,21.646,0,0,0-2.449-2.267c-.482.106.932.521.707.566l-.082.7,1.73.521S-18976.961,9225.5-18977.656,9224.633Z",
    transform: "translate(18994.844 -9220.975)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Path_7064_-_Outline",
    "data-name": "Path 7064 - Outline",
    d: "M0,0V19.909H16.142V2.69H13.434V.084L0,0M0-1H.006L13.44-.916a1,1,0,0,1,.994,1V1.69h1.709a1,1,0,0,1,1,1V19.909a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1-.7-.709,1,1,0,0,1,0-1Z",
    transform: "translate(1 1)",
    fill: "#3c3c3b"
  })), React.createElement("rect", {
    id: "Rectangle_2671",
    "data-name": "Rectangle 2671",
    width: 4.305,
    height: 0.807,
    rx: 0.404,
    transform: "translate(3.676 15.528)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Rectangle_2603_-_Outline",
    "data-name": "Rectangle 2603 - Outline",
    d: "M.4,0H3.9a.4.4,0,0,1,0,.807H.4A.4.4,0,0,1,.4,0Z",
    transform: "translate(3.676 15.528)",
    fill: "#3c3c3b"
  }), React.createElement("rect", {
    id: "Rectangle_2672",
    "data-name": "Rectangle 2672",
    width: 10.761,
    height: 0.807,
    rx: 0.404,
    transform: "translate(3.676 4.766)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Rectangle_2618_-_Outline",
    "data-name": "Rectangle 2618 - Outline",
    d: "M.4,0h9.954a.4.4,0,1,1,0,.807H.4A.4.4,0,1,1,.4,0Z",
    transform: "translate(3.676 7.461)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Rectangle_2619_-_Outline",
    "data-name": "Rectangle 2619 - Outline",
    d: "M.4,0h9.954a.4.4,0,1,1,0,.807H.4A.4.4,0,1,1,.4,0Z",
    transform: "translate(3.676 10.147)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Rectangle_2620_-_Outline",
    "data-name": "Rectangle 2620 - Outline",
    d: "M.4,0h9.954a.4.4,0,1,1,0,.807H.4A.4.4,0,1,1,.4,0Z",
    transform: "translate(3.676 12.832)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Path_7071",
    "data-name": "Path 7071",
    d: "M-19086.953,9281.927a.618.618,0,0,1-.254-.054c-.338-.15-.391-.489-.436-.788a3.426,3.426,0,0,0-.752-1.777.5.5,0,0,1,.086-.7.5.5,0,0,1,.7.087,4.414,4.414,0,0,1,.924,2.058c.061-.039.133-.086.217-.143a2.729,2.729,0,0,0,1.018-1.18c.107-.217.254-.514.609-.534h.037c.367,0,.574.323.814.7a7.961,7.961,0,0,0,.615.849.5.5,0,0,1,.449-.281.5.5,0,0,1,.182.034.5.5,0,0,1,.285.646c-.174.446-.43.69-.762.726a.839.839,0,0,1-.084,0c-.516,0-.92-.524-1.449-1.322a3.721,3.721,0,0,1-1.16,1.193A2.163,2.163,0,0,1-19086.953,9281.927Z",
    transform: "translate(19097.07 -9262.935)",
    fill: "#3c3c3b"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contract.ad984374.svg";
export { ForwardRef as ReactComponent };